import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { fieldPropTypes } from 'redux-form';
//
import DropdownMultiWithTags from 'components/FormFieldsSimple/DropdownMultiWithTags';
import { ReduxFormElementWrapper } from '../_ReduxFormElementWrapper';

export class DropdownFieldTags extends Component {
  static propTypes = {
    ...fieldPropTypes,
    onInputChange: PropTypes.func,
  };

  static defaultProps = {
    onInputChange: Function.prototype,
  };

  handleChange = (value) => {
    const { input, onHandleChange } = this.props;

    input.onFocus();
    input.onChange(value);

    if (this.props.formName && this.props.blockName) {
      onHandleChange(this.props.formName, this.props.blockName, value);
    }

    input.onBlur();
    this.props.onInputChange(value);
  };

  render() {
    const { input } = this.props;

    return (
      <ReduxFormElementWrapper {...this.props} childrenMarginTop="14px">
        <DropdownMultiWithTags
          {...this.props}
          onChange={this.handleChange}
          value={input.value}
        />
      </ReduxFormElementWrapper>
    );
  }
}
